<template>
  <van-dialog v-model="show" title=" " class="cucc-order-dialog"  :showConfirmButton="false">
    <div class="content"  >
      <!-- <div class="loading-box"
          v-if="isLoad"
            style="width: 100%; height: 100%; display: flex;justify-content: center;align-items: center; position: absolute; top: 0">
            <van-loading color="#db382c" />
          </div> -->
        <iframe :src="src" ref="container"  frameborder="0" style="border: none;width:100%"  scrolling="no"></iframe>

        <img v-show="!isLoad" src="@/assets/image/cucc-dialog/close.png" alt="" class="close-img" @click="close(true)">
    </div>
  </van-dialog>
</template>

<script>
// import { track } from '@/directives/track/send.js'
import { Toast } from 'vant'
export default {
  name: 'cucc-order-dialog',
  data () {
    return {
      show: false,
      resolve: null,
      reject: null,
      src: '',
      isLoad: true,
      hexColor: ''
    }
  },
  filters: {
    phoneFilter (value) {
      if (!value) return ''
      if (value.length > 0) {
        return value.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
      }
      return value
    }
  },
  methods: {
    init (resolve, reject, data) {
      this.isLoad = true
      this.resolve = resolve
      this.reject = reject
      this.src = data.src

      // 创建URL对象
      const urlObj = new URL(data.src)

      // 获取hexColor参数
      const hexColor = urlObj.searchParams.get('hexColor')?.replace(/^%23/, '#') || '#000000'
      this.hexColor = hexColor
      this.show = true
      window.addEventListener('message', this.loadFrame, false)
    },
    loadFrame (event) {
      if (typeof event.data === 'string') {
        const data = JSON.parse(event.data)
        console.log(data)
        this.isLoad = false
        Toast.clear()
        const str = data.data?.RSP?.HEIGHT
        let pureNumbers = str
        if (typeof str === 'string') {
          pureNumbers = parseInt(str.replace(/\D+/g, ''))
        }

        // 计算弹窗高度 515 400
        // const containerHeight = (pureNumbers + 40) / 37.5
        const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize)
        // 展示退订规则
        // const targetPixels = pureNumbers + 115
        // 不展示推定规则
        const targetPixels = pureNumbers
        const containerHeight = targetPixels / rootFontSize

        this.$nextTick(() => {
          if (pureNumbers !== 0) {
            this.$refs.container && containerHeight && (this.$refs.container.style = `height:${containerHeight}rem;width:100%`)
            containerHeight && sessionStorage.setItem('dialogHeight', containerHeight)
          } else {
            this.$refs.container && (this.$refs.container.style = 'height:9.5rem;width:100%')
          }
        })
        if (data.type === 'navigateBack') {
          // 返回
          this.close(true)
        }
        if (data.type === 'success') {
          window.removeEventListener('message', this.loadFrame, true)
          /// 执行跳转结果
          // sessionStorage.setItem('isCloseDialog', 'closeDialog') // 控制弹窗弹出
          this.close()
          this.resolve()
        }
      }
    },
    close (cancel) {
      this.show = false
      this.src = ''
      // const params = {
      //   h5_color_ring_general_popup_event_type: '2',
      //   h5_color_ring_general_popup_type: '6',
      //   popup_title: '确认办理',
      //   popup_content: '联通订购',
      //   button_name: '取消按钮'
      // }
      // track([{ event_id: 'h5_color_ring_general_popup', event_param: params }])
      if (cancel) {
        this.reject()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.cucc-order-dialog{
  width:11rem;
  background: transparent;
  display: flex;
  flex-direction: column;
  :deep(.van-dialog__header){
    display:none
  }
  :deep(.van-dialog__content){
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}
.content {
  padding-top: 0px;
  font-size: 14px;
  width:100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  background: transparent;
  .close-img{
    margin-top: 10px;
    height:40px;
    width:40px;
  }
}

</style>
